export const CLOSE_SNACKBAR = 'SNACKBAR/CLOSE_SNACKBAR'

export const SHOW_SNACKBAR = 'SNACKBAR/SHOW_SNACKBAR'

export const UPDATE_SNACKBAR = 'SNACKBAR/UPDATE_SNACKBAR'
